module.exports = __webpack_public_path__ + "static/media/logo-black.6836c143.png";